import { Component, ElementRef, HostListener, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ItemService } from '../../item/item.service';
import { SectionService } from '../../section/section.service';
import { SettingService } from '../../setting/setting.service';
import { Answer, Inspection } from '../../shared/interfaces';
import { MergeAnswersService } from '../../shared/merge.answers.service';
import { VersionService } from '../../version/version.service';
import { AnswerService } from '../answer.service';
import { InspectionService } from '../inspection.service';
import { InspectionFilters } from '../review.navigation/review.navigation.component';

@Component({
  selector: 'app-inspection-snapshot',
  templateUrl: './inspection-snapshot.component.html',
  styleUrls: ['./inspection-snapshot.component.scss'],
})
// tslint:disable:max-line-length
export class InspectionSnapshotComponent implements OnInit, OnChanges {
  constructor(
    public inspectionService: InspectionService,
    public itemService: ItemService,
    public answerService: AnswerService,
    public sectionService: SectionService,
    public versionService: VersionService,
    public route: ActivatedRoute,
    private toastr: ToastrService,
    public mergeAnswersService: MergeAnswersService,
    public router: Router,
    public settingService: SettingService,
  ) {
    // this._questionFilter = getCurrentMandatoryReviewFilter() || 'mandatory';
  }
  // get questionFilter() {
  //   return this._questionFilter;
  // }
  // set questionFilter(f) {
  //   this._questionFilter = f;
  //   setCurrentMandatoryReviewFilter(f);
  //   this.buildTable();
  // }

  @ViewChild('scrollDiv', { static: false }) scrollDiv: ElementRef;

  // _questionFilter: string;

  items: any[];
  rawSections: any;
  rawItems;
  any;
  config = {
    sorting: 'none',
    hideWithoutComments: false,
    hideWithoutFlags: false,
    followConfigurationOrder: true,
    items: [0],
    sections: [0],
  };

  mainTable = {
    headers: [],
    sections: [],
  };

  ownerInterviewTable = {
    headers: [],
    sections: [],
  };

  poultryHousesTable = {
    headers: [],
    sections: [],
  };

  generatorBuildingsTable = {
    headers: [],
    sections: [],
  };

  litterShedsTable = {
    headers: [],
    sections: [],
  };

  dwellingsTable = {
    headers: [],
    sections: [],
  };

  overallImpressionTable = {
    headers: [{ text: 'N/A' }],
    sections: [],
  };

  @Input() inspection: Inspection;
  @Input() answers: Answer[] = [];
  @Input() filters: InspectionFilters;

  structure: any;
  scoresEnabled = true;
  hiddenColumns = [];

  async ngOnInit() {
    this.scoresEnabled = await this.settingService.scoresEnabled();
  }

  async ngOnChanges(changes: SimpleChanges) {
    if ('answers' in changes) {
      if (this.answers) {
        await this.load();
        this.buildTable();
      }
    }
    if ('filters' in changes) {
      this.buildTable();
    }
  }

  async load() {
    // Load question structure
    this.structure = await this.versionService.tree(this.inspection.versionId);

    // Load answers
    this.items = [...(await this.mergeAnswersService.loadItems(this.inspection, this.answers))];
    this.mergeAnswersService.mergeAnswers(this.items);
    this.items.sort((a, b) => a.order - b.order);
  }

  buildTable() {
    if (this.inspection && this.items) {
      this.mainTable.headers = this.items.map(item => {
        return {
          text: item.label,
          filter: item.label,
        };
      });

      this.hiddenColumns = [];

      this.mainTable.headers.forEach((header, index) => {
        let show = true;

        if (this.filters && !this.filters.items.includes(0)) {
          // Apply filter
          show = this.filters.items.includes(header.filter);
        }

        if (!show) {
          this.hiddenColumns.push(index);
        }
      });
      const sectionSet = new Set();

      this.mainTable.sections = this.items.reduce((sections, item) => {
        item.sections.forEach(section => {
          const sectionKey = `${item.name} - ${section.name}`;
          if (!sectionSet.has(sectionKey)) {
            sectionSet.add(sectionKey);

            const newSection = {
              name: sectionKey,
              rows: section.questions
                .filter(question => this.shouldShowQuestion(question, section, item))
                .map(row => {
                  return {
                    header: row.text,
                    legacyId: row.legacyId,
                    values: this.items.map(header => {
                      if (row.repeat.length) {
                        if (row.repeat.includes(header.id)) {
                          return (
                            row.answer.find(ans => !header.index || ans.buildingIndex === header.index) || {
                              answer: '',
                            }
                          );
                        }
                        return { answer: '' };
                      }

                      if (row.section.item.id === header.id) {
                        const headerSection = header.sections.find(s => s.id === section.id);
                        if (headerSection) {
                          const headerQuestion = headerSection.questions.find(q => q.id === row.id);
                          if (headerQuestion) {
                            return headerQuestion.answer;
                          }
                        }
                      }

                      return { answer: '' };
                    }),
                  };
                }),
            };
            sections.push(newSection);
          }
        });

        return sections;
      }, []);

      setTimeout(() => {
        this.setTableHeight();
      }, 1);
    }
  }

  isHidden(i) {
    return this.hiddenColumns.includes(i);
  }

  gotoQuestion(x) {
    const queryParams = this.getAnswerPath(x);
    this.router.navigate([`/inspection/review/main/`, this.inspection.id], {
      queryParams,
      queryParamsHandling: 'merge',
    });
  }

  // tslint:disable:forin
  getAnswerPath(x) {
    for (const item in this.items) {
      for (const section in this.items[item].sections) {
        for (const question in this.items[item].sections[section].questions) {
          const answer = this.items[item].sections[section].questions[question].answer;
          if (!answer) {
            continue;
          }
          if (Array.isArray(answer)) {
            if (answer.find(a => a.id === x.id)) {
              return { item, section, question };
            }
          } else {
            if (answer.id === x.id) {
              return { item, section, question };
            }
          }
        }
      }
    }
  }

  shouldShowQuestion(question, section, item) {
    const answers = this.answers.filter(answer => answer.questionId === question.id);
    let hasAnswers = answers.length > 0;
    const mandatory = hasAnswers && question.mandatoryReview;

    if (this.filters) {
      if (this.filters.flags && this.filters.flags !== 'all') {
        const filteredAnswers = answers.filter(answer =>
          answer.flags.some(flag => this.filters.flags !== 'all' && this.filters.flags.includes(flag.subtypeId)),
        );
        hasAnswers = filteredAnswers.length > 0;
        if (!hasAnswers) {
          return false;
        }
      }

      if (!this.filters.items.includes(0) && !this.filters.items.find(filter => filter.includes(item.name))) {
        return false;
      }

      if (!this.filters.sections.includes(0) && !this.filters.sections.includes(section?.id)) {
        return false;
      }

      if (this.filters.questions === 'mandatory') {
        return mandatory;
      }

      const scored = hasAnswers && this.getScore(answers);

      if (this.filters.questions === 'scored') {
        return scored;
      }
      if (this.filters.questions === 'mandatoryOrScored') {
        return mandatory || scored;
      }

      if (this.filters.questions === 'autoScored') {
        const flags = answers.reduce((acc, ans) => [...acc, ...ans.flags], []);
        if (!flags.find(x => x.systemFlag)) {
          return false;
        }
        return true;
      }
    }

    return hasAnswers;
  }

  getScore(answers) {
    return answers ? answers.reduce((sum, ans) => sum + (ans.flaggingScore || 0), 0) : 0;
  }

  @HostListener('window:resize')
  setTableHeight() {
    this.scrollDiv && (this.scrollDiv.nativeElement.style.height = window.innerHeight - 200 + 'px');
  }
}
